module.exports = __webpack_public_path__ + "static/media/top-bg.68a9acd8.png";